var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashIconRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.324463,
    width: 28,
    height: 28,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_970_2311",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_970_2311",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAACWklEQVR4nO3dsWtTURTH8Ss66qCzCDk3qVCxzbkWqV0KOusg6H8gzoIibiIO/gMKxf+gk+AfoIvYwVkEcdbck2J17NDIW1w6SUzvL+n3A2dN3jtfXuBluSkBAAAAAA6p3n8QbtvTTPcZhz8Z/yw8P42SJ/9jaskvSCASI4iiFyOOU5RJSifC7UYUexRuj6ec17OK8Xe675j2Okt+GMWud/eelOytnz8Xxd7PfIlFc6rbu73LF84mFeH5beulROsoxd4kBXWlt9R6GSEyI899hafjVutFhMp4/2brHmnX87XmiygaMy799dY90mRz81S4fWu9jGg+9nVyJ51MCkbDvFHdfrdfSm4y1e1X90uRlPxYG1j1/Kq67UTJn47DVLed6vby+8pSr/X+AQAAAEDqBbH1C1sc0XT3mtTtruZLrf/KiCOa7l6TOoKIIYgYgoghiBiCiCGIGIKIIYgYgoghiBiCiCGIGIKIIYgYgoghiBiCiCGIGIKIIYgYgoghiBiCiCGIGIKIIYgYgoghiBiCiCGIGIKIIYgYgoghiBiCiCGIGIKIIYgYgoghiBiCiCGIGIKIIYgYgoghiBiCiCGIGIKIIYgYgoghiJg6tMGxOTdkaIOkLjYunmm9qDiiGS0vn07zoHr+svBPR7HPaV5EseetFxazHs/P0rzoTr2snncX9+nIP7vTTdM8GbvdriUfLGCMg1ry3TSPwu1+ddtfmBhu+7Xke2medYctVrePrZcZU499GF/pXU2Loq71fVzykyh5K9y252JK3uquebQ6GLbeHwAAAACkGfkDc3UaQRzXRwYAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIconRed);
export default __webpack_public_path__ + "static/media/trash-icon-red.ac2891821129cfd04e189e8d23aa75d2.svg";
export { ForwardRef as ReactComponent };